export const dealListData = [
  {
    key:"1",
    DealName: "Collins",
    Stage: "Quality To Buy",
    DealValue: "$4,50,000",
    Tags: "Promotion",
    ExpectedClosedDate: "14 Jan 2024",
    Owner: "Hendry Milner",
    Probability: "70%",
    Status: "Open",
  },
  {
    key:"2",
    DealName: "Konopelski",
    Stage: "Proposal Made",
    DealValue: "$3,15,000",
    Tags: "Rated",
    ExpectedClosedDate: "21 Jan 2024",
    Owner: "Guilory Berggren",
    Probability: "85%",
    Status: "Won",
  },
  {
    key:"3",
    DealName: "Adams",
    Stage: "Contact Made",
    DealValue: "$8,40,000",
    Tags: "Promotion",
    ExpectedClosedDate: "20 Feb 2024",
    Owner: "Jami Carlile",
    Probability: "60%",
    Status: "Open",
  },
  {
    key:"4",
    DealName: "Schumm",
    Stage: "Quality To Buy",
    DealValue: "$6,10,000",
    Tags: "Collab",
    ExpectedClosedDate: "15 Mar 2024",
    Owner: "Theresa Nelson",
    Probability: "75%",
    Status: "Won",
  },
  {
    key:"5",
    DealName: "Wisozk",
    Stage: "Presentation",
    DealValue: "$4,70,000",
    Tags: "Rejected",
    ExpectedClosedDate: "12 Apr 2024",
    Owner: "Smith Cooper",
    Probability: "80%",
    Status: "Won",
  },
  {
    key:"6",
    DealName: "Heller",
    Stage: "Appointment",
    DealValue: "$5,50,000",
    Tags: "Rated",
    ExpectedClosedDate: "20 May 2024",
    Owner: "Martin Lewis",
    Probability: "65%",
    Status: "Lost",
  },
  {
    key:"7",
    DealName: "Gutkowski",
    Stage: "Qualify to Buy",
    DealValue: "$5,00,000",
    Tags: "Calls",
    ExpectedClosedDate: "06 Jul 2024",
    Owner: "Newell Egan",
    Probability: "90%",
    Status: "Lost",
  },
  {
    key:"8",
    DealName: "Walter",
    Stage: "Proposal Made",
    DealValue: "$4,50,000",
    Tags: "Rejected",
    ExpectedClosedDate: "02 Sep 2024",
    Owner: "Janet Carlson",
    Probability: "55%",
    Status: "Won",
  },
  {
    key:"9",
    DealName: "Hansen",
    Stage: "Presentation",
    DealValue: "$6,20,000",
    Tags: "Collab",
    ExpectedClosedDate: "15 Nov 2024",
    Owner: "Craig Brown",
    Probability: "95%",
    Status: "Lost",
  },
  {
    key:"10",
    DealName: "Leuschke",
    Stage: "Appointment",
    DealValue: "$7,40,000",
    Tags: "Calls",
    ExpectedClosedDate: "10 Dec 2024",
    Owner: "Daniel Byrne",
    Probability: "50%",
    Status: "Won",
  },
];
